<template>
    <div class="exp_edu" id="education" style="margin-top: 16px">
        <b-container class="exp_content">
            <b-row class="cover">
                <b-card :img-src="cover" img-alt="education" img-top>
                    <b-card-text>
                        <h2>Education</h2>
                        <p>I consider myself a lifelong learner who’s not only eager to acquire new skills and
                            knowledge, but also committed to maintaining an open-minded, positive attitude in a
                            constantly changing world.</p>
                    </b-card-text>
                    <figure class="cover_icon">
                        <b-img :src="coverIcon"></b-img>
                    </figure>
                </b-card>
            </b-row>
            <b-row v-for="(info, i) in information" :key="i" class="exp_center_content">
                <b-col style="overflow: auto;">
                    <div class="content">
                        <div class="logo">
                            <figure>
                                <b-img fluid :src="info.logo"></b-img>
                            </figure>
                        </div>
                        <div class="content_body">
                            <p> <strong style="font-size: 20px">{{ info.degree }}</strong> #{{ info.year }}</p>
                            <p style="margin-bottom: 10px"><em> <strong>@{{ info.school }}</strong></em></p>
                            <div v-for="(b, i) in info.body" :key="i">
                                <p>{{ b }}</p>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            information: [
                {
                    school: 'Udemy',
                    year: 'Mar 2019 - Present',
                    degree: 'Courses and Training',
                    body: [
                        'The web developer bootcamp _ Colt Steele',
                        'vue - the complete guide _ Maximilian Schwarzamuller',
                        'Mordern React with redux _ Stephen Grider',
                        'Complete React developer course _ Andrew Mead',
                        'The complete Nodejs developer course _ Andrew Mead',
                    ],
                    logo: require('../assets/education/udemy.png'),
                },
                {
                    school: 'Banking University of Ho Chi Minh city',
                    year: 'Nov 2006 - April 2015',
                    degree: 'Master\'s in Banking and Finance',
                    body: [
                        'Thesis: The relationship between GDP growth and the development of the stock market in Vietnam',
                    ],
                    logo: require('../assets/education/banking_uni.png'),
                },
            ],
            cover: require('../assets/education/edu_cover.jpg'),
            coverIcon: require('../assets/education/certificate.png'),
        }
    },
}
</script>

<style lang="scss">
@import '../styles/views/Experience.scss'
</style>
